import Vue from 'vue'
import Vuex from 'vuex'
import delayFollowUpRecord from './modules/delayFollowUpRecord';
Vue.use(Vuex);
// 导出需要的模块
const store = new Vuex.Store({
    modules: {
        delayFollowUpRecord,
    }
  })
  
export default store


// WEBPACK FOOTER //
// ./src/store/index.js